import { PROTOCOL } from "./constants.js";
import { Logger } from "./logger.js";
async function sendProgressNotification(extra, progress, total, message) {
    const progressToken = extra._meta?.progressToken;
    if (!progressToken)
        return;
    try {
        const params = { progressToken, progress };
        if (total !== undefined)
            params.total = total;
        if (message)
            params.message = message;
        await extra.sendNotification({
            method: PROTOCOL.NOTIFICATIONS.PROGRESS,
            params,
        });
    }
    catch (error) {
        Logger.error("Failed to send progress notification:", error);
    }
}
export function createProgressTracker(operationName, extra, messages) {
    let active = true;
    let latestOutput = "";
    let messageIndex = 0;
    let progress = 0;
    sendProgressNotification(extra, 0, undefined, `Starting ${operationName}`);
    const interval = setInterval(async () => {
        if (active) {
            progress += 1;
            const baseMessage = messages[messageIndex % messages.length];
            const outputPreview = latestOutput.slice(-150).trim();
            const msg = outputPreview ? `${baseMessage}\nOutput: ...${outputPreview}` : baseMessage;
            await sendProgressNotification(extra, progress, undefined, msg);
            messageIndex++;
        }
        else {
            clearInterval(interval);
        }
    }, PROTOCOL.KEEPALIVE_INTERVAL);
    return {
        interval,
        async stop(success) {
            active = false;
            clearInterval(interval);
            await sendProgressNotification(extra, 100, 100, success ? `${operationName} completed` : `${operationName} failed`);
        },
        updateOutput(output) {
            latestOutput = output;
        },
    };
}
//# sourceMappingURL=progressTracker.js.map